import React from 'react';

const ThinxLogo = ({ width = 60, logoUrl }) => {
  if (!logoUrl) return null;

  return (
    <div className="thinx-logo">
      <img
        src={logoUrl}
        alt="Thinx Logo"
        width={width}
      />
    </div>
  );
};

export default ThinxLogo;
